import type { EntityType, StaticEntityType, StaticLayerPayload } from "@config";
import type { ComponentType } from "react";

export enum CarouselStyleEnum {
  Regular = "regular",
  FullScreen = "full-screen",
}

export enum CarouselContainerEnum {
  SideBySide = "side-by-side",
  Stacked = "stacked",
}

export enum CarouselAnimationTypeEnum {
  SlideIn = "slide-in",
  FadeIn = "fade-in",
}

export enum CarouselAutoplaySpeedEnum {
  Slow = "slow",
  Medium = "medium",
  Fast = "fast",
}

export interface ICarouselSpecificSettings {
  carouselStyle: CarouselStyleEnum;
  carouselContainer: CarouselContainerEnum;

  carouselBulletsColor: string;
  carouselBulletsColorActive: string;
  carouselBulletsOpacity: number;
  carouselBulletsOpacityActive: number;

  carouselAnimationType: CarouselAnimationTypeEnum;
  carouselAutoplaySpeed: CarouselAutoplaySpeedEnum;
  carouselAutoplayActive: boolean;
}

export interface ICarouselSettings extends ICarouselSpecificSettings {
  name: string;
  horizontalAlignment: string;
  maxWidth: string;
}

export interface ICarouselItemBgImageData {
  carouselBgImageSrc?: string;
  carouselBgImageAlt?: string;
  carouselBgImageOverlay?: boolean;
  carouselBgImageOverlayColor?: string;
  carouselBgImageOverlayOpacity?: number;
  carouselBgImageBlackAndWhite?: boolean;
}

export interface ICarouselEditorData {
  EditorItem: ComponentType<{ set: EntityType }>;
  setActiveItem: (itemId: string) => void;
}

export type ICarouselSets = EntityType[] | StaticEntityType[];
export type ICarouselSetComponent = ComponentType<
  { id: string } | StaticLayerPayload
>;
